import { render, staticRenderFns } from "./DeviceConfigInstructions.vue?vue&type=template&id=81387d42&scoped=true&"
import script from "./DeviceConfigInstructions.vue?vue&type=script&lang=js&"
export * from "./DeviceConfigInstructions.vue?vue&type=script&lang=js&"
import style0 from "./DeviceConfigInstructions.vue?vue&type=style&index=0&id=81387d42&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81387d42",
  null
  
)

export default component.exports